import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';


const OutlineButton = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'normal',
    padding: '0',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: 'transparent',
    color: "#fff",
    borderColor: '#fff',
    position: 'absolute',
    right: '10px',
    top: '10px',
    minWidth: 'auto',
    width: '25px',
    height: '25px',
    borderRadius: '50px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: '#fff',
      color: '#34A595',
      borderColor: '#34A595',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#34A595',
      borderColor: '#34A595',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  });
const ToastMessage = React.memo(({ type, message, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);

    // Use useCallback to memoize the handler
    const hideToastHandler = useCallback(() => {
        setIsVisible(false);
        onClose(); // Notify parent to remove the toast
    }, [onClose]);

    // Use useEffect to handle auto-dismiss
    useEffect(() => {
        const timer = setTimeout(() => {
            hideToastHandler();
        }, 5000);

        return () => clearTimeout(timer);
    }, [hideToastHandler]);

    let _className = '';
    let toastText = '';
    let ico = '';

    switch(type) {
        case 'info':
            _className = "info-toaster";
            toastText = "Info"
            ico = "?";
            break;
        case 'success':
            _className = "success-toaster";
            toastText = "Success";
            ico = "&#10003;";
            break;
        case 'error':
            _className = "error-toaster";
            toastText = "Error";
            ico = "&#10005;";
            break;
        default:
            _className = "warning-toaster";
            toastText = "Warning";
            ico = "!";
    }

    // Only render if visible
    if (!isVisible) return null;

    return (
        <Box className={`custom-toaster popreveal ${_className}`}>
            <Box className="ico">
                <span dangerouslySetInnerHTML={{__html: ico}}></span>
            </Box>
            <Typography
                className='tost-message-heading'
                variant="h4"
            >
                {toastText}
            </Typography>
            <Typography
                className='tost-message-text'
                variant="body1"
                dangerouslySetInnerHTML={{ __html: message }}
            >
            </Typography>
            <OutlineButton
                variant="outlined"
                onClick={hideToastHandler}
            >
                &#10005;
            </OutlineButton>
        </Box>
    );
});


export default ToastMessage;